<ng-container rtBlock="sc-blog-embed-block">
    @if (src(); as frameSrc) {
        <iframe
            rtElem="frame"
            loading="lazy"
            allow="encrypted-media; picture-in-picture; fullscreen"
            referrerpolicy="strict-origin-when-cross-origin"
            [src]="frameSrc"
            [title]="title()"></iframe>
    }
</ng-container>
